import React from 'react';
import { saveAs } from 'file-saver';

import styles from './styles.module.scss';
import moment from 'moment';

import { getDesempenhoLogStatusResultado } from './../../../../services/api-auto';

const  handleClick = async (id,statusId, status) => {
    try {
        const retorno = await getDesempenhoLogStatusResultado(id,statusId)
        saveAs(retorno, 'Relatorio de '  + status +'.xlsx')

    }catch {
        alert('Houve um erro ao baixar o arquivo')
    }
}


const logImportacao = ({ log }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.gray}>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Data e hora:
                    </div>
                    <div className={styles.info}>
                       { new moment(log.dataHoraImportacao).format('DD/MM/YYYY hh:mm:ss') }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Importado por:
                    </div>
                    <div className={styles.info}>
                        { log.nomeUsuario }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Mês de apuração:
                    </div>
                    <div className={styles.info}>
                        { new moment(log.mesApuracao.slice(0, 2), 'MM').format('MMMM') }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Campanha:
                    </div>
                    <div className={styles.info}>
                        { log.nomeCampanha }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Arquivo:
                    </div>
                    <div className={styles.info}>
                        { log.nomeArquivo }
                    </div>
                </div>
            </div>
            <div className={styles.white}>
                <div className={styles.bigLabel}>
                    Registros
                </div>
                <div className={styles.registros}>
                    <div className={styles.registrosWrapper}>
                        <div className={styles.registroslabel}>
                            totais
                        </div>
                        <div className={styles.registrosInfoTotais}>
                            {log.total}
                        </div>
                    </div>
                    <div className={styles.registrosWrapper} onClick={() => handleClick(log.id, 1, 'SUCESSO')}>
                        <div className={styles.registroslabel}>
                            Ok
                        </div>
                        <div className={styles.registrosInfoOk}>
                            {log.ok}
                        </div>
                    </div>
                    <div className={styles.registrosWrapper} onClick={() => handleClick(log.id, 3, 'Alertas')}>
                        <div className={styles.registroslabel}>
                            Alertas
                        </div>
                        <div className={styles.registrosInfoAlertas}>
                            {log.aviso}
                        </div>
                    </div>
                    <div className={styles.registrosWrapper} onClick={() => handleClick(log.id, 2, 'Duplicados')}>
                        <div className={styles.registroslabel}>
                            Duplicados
                        </div>
                        <div className={styles.registrosInfoDuplicados}>
                            {log.duplicado}
                        </div>
                    </div>
                    <div className={styles.registrosWrapper} onClick={() => handleClick(log.id, 4, 'Erros')}>
                        <div className={styles.registroslabel}>
                            Erros
                        </div>
                        <div className={styles.registrosInfoErros}>
                            {log.erro}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.gray} ${styles.status}`}>
                {   
                    log.erro === 0 ? (
                        <div className={styles.successWrapper}>
                            {log.status?.toUpperCase()}
                        </div>
                    ) : (
                        <div className={styles.errorWrapper}>
                            {log.status?.toUpperCase()}
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default logImportacao